<div class="collapsible-card-mask"
     [class.disabled]="hasMask"
     [class.collapsed]="isCollapsed"> <!-- ← ADICIONE isCollapsed -->
  <div class="collapsible-card-mask__footer" *ngIf="hasMask">
    <span>Em breve...</span>
    <img src="assets/icons/lockIcon.png" alt="Bloqueado" class="lock-icon">
  </div>
  <div class="collapsible-card-mask__overlay" *ngIf="hasMask"></div>

  <!-- Container para o conteúdo que será bloqueado quando a máscara estiver ativa -->
  <div class="collapsible-card-mask__content">
    <ng-content></ng-content>
  </div>
</div>
